<template>
    <table>
        <tr class="center">
        <td colspan="5">Переводы {{title}}</td>
        </tr>
        <tr>
        <td  v-for="lang in languages" :key="lang.locale+title+'1'">
            <b> {{lang.locale}} </b>
        </td>
        </tr>
        <tr>
        <td v-for="(lang) in languages" :key="lang.locale+title+'2'">
            <b> {{lang.count}} </b>
        </td>
        </tr>
    </table>
</template>


<script>
export default {
    props:['translations', 'title'],
    data: function(){
      return {
        languages: {
          "en": {
            "locale": "en",
            "count": 0
          },
          "ru": {
            "locale": "ru",
            "count": 0
          },
          "uz-Cyrl": {
            "locale": "uz-Cyrl",
            "count": 0
          },
          "uz-Latn": {
            "locale": "uz-Latn",
            "count": 0
          },
        }
      }
    },
    methods:{
      updateLanguages(){
        this.translations.map((el)=>{
          this.$set(this.languages, el.locale, el);
        })
      }
    },
    watch:{
      'translations': 'updateLanguages'
    }

};
</script>
<style lang="scss" scoped>
table {
  border: 0.01em solid #39394d;
  width: 100%;
  margin-top: 1em;
  align-content: center;
  text-align: center;

}
tbody{
    border-collapse: separate;
}
th, td{

  font-size: 1.3em;
  color: #39394d;
  width: 25%;
  text-align: center;
}
</style>
